module.exports = __webpack_public_path__ + "img/ironshore-logo.28ccc91d.svg";